import React from "react"
import { Helmet } from "react-helmet"

export const ComingSoon = () => {
    return (
        <>
            <Helmet>Coming Soon | Metropolis</Helmet>
            <div className="ground-color-berry">
                <div className="mtp-container">
                    <div className=" flex-center py-16 text-center">
                        <h1 className="fw-700 text-color-white my-16 py-16">COMING SOON</h1>
                    </div>
                </div>
            </div>
        </>
    )
}